import { render, staticRenderFns } from "./WebHosting.vue?vue&type=template&id=096eca0b&"
import script from "./WebHosting.vue?vue&type=script&lang=js&"
export * from "./WebHosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports